/**
 * Cart Upsell Quick Add functionality
 * Uses event delegation so it works even after Dawn's AJAX cart updates
 * Lets Dawn handle DOM updates via pub/sub for consistency
 */
(function() {
  'use strict';
  
  // Prevent duplicate initialization
  if (window.cartUpsellInitialized) return;
  window.cartUpsellInitialized = true;
  
  // Use event delegation on document - catches all clicks regardless of when elements were added
  document.addEventListener('click', handleUpsellClick);
  
  async function handleUpsellClick(e) {
    // Check if clicked element is an upsell add button (or inside one)
    const button = e.target.closest('.cart-upsell__add-btn');
    if (!button) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    // Prevent double-clicks or clicks on disabled buttons
    if (button.disabled || button.classList.contains('cart-upsell__add-btn--loading')) {
      return;
    }
    
    const variantId = button.dataset.variantId;
    const item = button.closest('.cart-upsell__item');
    
    if (!variantId) return;
    
    // Show loading state
    button.disabled = true;
    button.classList.add('cart-upsell__add-btn--loading');
    
    // Fade out the item immediately for visual feedback
    if (item) {
      item.classList.add('cart-upsell__item--adding');
    }
    
    try {
      // Add item to cart
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      });
      
      const responseData = await addResponse.json().catch(() => ({}));
      
      if (!addResponse.ok) {
        resetButton(button);
        if (item) item.classList.remove('cart-upsell__item--adding');
        return;
      }
      
      // Mark as fully added (triggers fade out)
      if (item) {
        item.classList.remove('cart-upsell__item--adding');
        item.classList.add('cart-upsell__item--added');
      }
      
      // Let Dawn's pub/sub system handle the cart-items update
      // This ensures all event listeners and custom elements work properly
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { 
          source: 'cart-upsell', 
          cartData: responseData,
          variantId: variantId 
        });
      } else {
        // Fallback: manually trigger Dawn's cart update
        const cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.onCartUpdate === 'function') {
          cartItems.onCartUpdate();
        }
      }
      
      // Dawn's onCartUpdate only refreshes cart-items, NOT the footer/totals
      // So we manually fetch and update the cart footer section
      updateCartFooter();
      
    } catch (error) {
      resetButton(button);
      if (item) item.classList.remove('cart-upsell__item--adding');
    }
  }
  
  /**
   * Fetch and update the cart footer (estimated total) after adding an item.
   * Dawn's onCartUpdate only handles cart-items, so we need this for the totals.
   */
  async function updateCartFooter() {
    try {
      const footer = document.getElementById('main-cart-footer');
      if (!footer || !footer.dataset.id) return;
      
      const sectionId = footer.dataset.id;
      const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
      
      if (!response.ok) return;
      
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newFooterContent = doc.querySelector('.js-contents');
      const currentFooterContent = footer.querySelector('.js-contents');
      
      if (newFooterContent && currentFooterContent) {
        currentFooterContent.innerHTML = newFooterContent.innerHTML;
      }
    } catch (e) {
      // Silent fail - totals will update on next page load
    }
  }
  
  function resetButton(button) {
    if (button) {
      button.disabled = false;
      button.classList.remove('cart-upsell__add-btn--loading');
    }
  }
})();
